'use client';

import { useParams } from 'next/navigation'

import { createContext, useContext, useState } from 'react'
import { useQueryCompanyDetails } from '@src/apis/shared/get-company-detail';

const GlobalCtx = createContext();

export const GlobalProvider = ({ children }) => {
  const { companySlug } = useParams()

  const [showLoader, setShowLoader] = useState(false)
  const { data: companyDetails } = useQueryCompanyDetails(companySlug)
  
  const [custProfile, setCustProfile] = useState(null)
  const [listListingUrl, setListListingUrl] = useState("")
  return (
    <GlobalCtx.Provider value={{
      showLoader,
      setShowLoader,
      companyDetails,
      custProfile, 
      setCustProfile,
      setListListingUrl,
      listListingUrl
    }}>
      {children}
    </GlobalCtx.Provider>
  )
}

const useGlobalCtx = () => {
  const ctx = useContext(GlobalCtx);

  if (!ctx) {
    throw new Error("useGlobalCtx must be used within the GlobalProvider");
  }

  return ctx;
};


export default useGlobalCtx